import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { Box, Container, Grid } from "@mui/material";
import campingList from "./campingList.json";
import BatumiBeach from "./BatumiBeach";
import "./scss/CampingZone.scss";

const CampingZone = () => {
  const [selectedCamping, setSelectedCamping] = useState(null);

  const handleCampingClick = (id) => {
    setSelectedCamping(id);
  };

  useEffect(() => {
    if (selectedCamping !== null) {
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    }
  }, [selectedCamping]);

  const CityCard = ({ campingInfo }) => {
    const { id, name, imgSrc } = campingInfo;

    return (
      <Box
        className="camping-card"
        sx={{
          width: 300,
          height: 300,
        }}
      >
        <Card>
          <CardMedia
            className="camping-img"
            component="img"
            image={imgSrc}
            alt={name}
            sx={{
              width: 300,
              height: 300,
              backgroundColor: "primary.dark",
            }}
          />
            
          <Box
            className="camping-description"
            onClick={() => handleCampingClick(id)}
            >
            {name}
          </Box>
          
        </Card>
      </Box>
    );
  };

  return (
    <Container maxWidth="lg" className="camping-container">
      <Grid container spacing={3}>
        {campingList.map((camping, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            component={motion.div}
            initial={{
              opacity: 0,
              translateX: -50,
              translateY: -50,
            }}
            animate={{
              opacity: 1,
              translateX: 0,
              translateY: 0,
            }}
            transition={{
              duration: 0.7,
              delay: index * 0.5,
            }}
          >
            <CityCard campingInfo={camping} />
          </Grid>
        ))}
      </Grid>

      <Grid >
      {selectedCamping === 1 ? <BatumiBeach dataId={1} /> : null}
      {selectedCamping === 2 ? <BatumiBeach dataId={2} /> : null}
      {selectedCamping === 3 ? <BatumiBeach dataId={3} /> : null}
      {selectedCamping === 4 ? <BatumiBeach dataId={4} /> : null}
      {selectedCamping === 5 ? <BatumiBeach dataId={5} /> : null}
      {selectedCamping === 6 ? <BatumiBeach dataId={6} /> : null}
      </Grid>
    </Container>
  );
};

export default CampingZone;
